const subTypes = {
  sectionMap: 'Section Map',
  contourSectionMap: 'Contour Section Map',
  timeSeries: 'Time Series',
  histogram: 'Histogram',
  depthProfile: 'Depth Profile',
  heatmap: 'Heatmap',
  contourMap: 'Contour Map',
  sparse: 'Sparse',
};

export default Object.freeze(subTypes);
